import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";
interface AverageRatings {
  occasion: Record<string, number>;
  colour: Record<string, number>;
  articleType: Record<string, number>;
  season: Record<string, number>;
  brand: Record<string, number>;
}

interface GetAverageRatingsParams {
  jobId: string;
  date: string;
}

const getAverageRatings = async ({
  jobId,
  date,
}: GetAverageRatingsParams): Promise<AverageRatings> => {
  return apiClient
    .get(ENDPOINTS.GET_INSIGHTS_AVERAGE_RATINGS(jobId, date))
    .json<AverageRatings>();
};

export const useGetAverageRatingsQuery = (
  params: GetAverageRatingsParams,
  options?: Omit<UseQueryOptions<AverageRatings, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["averageRatings", params.jobId, params.date],
    queryFn: () => getAverageRatings(params),
    ...options,
  });
};
